module.exports = __webpack_public_path__ + "com_index_5fig2.png?ce5c30ebb1037ef9cf5abfb5d93d4da0";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_5fig2.png
// module id = 125
// module chunks = 0